import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Client } from 'src/app/entity/exhibitor';

@Component({
  selector: 'app-note-client',
  templateUrl: './note-client.component.html',
  styleUrls: ['./note-client.component.css']
})
export class NoteClientComponent implements OnInit {
  @Input()selectedClient:Client;

  constructor(private router:Router) { }

  ngOnInit(): void {
  }
  clickedMe(){
    this.router.navigateByUrl(`/add-exhibitor/${this.selectedClient.idClient}/6`  )  

  }
}
